module.exports = __webpack_public_path__ + "static/img/logo.af12fa4e.png";